/* Krawler product page — gallery, variant selection, add to cart, sticky mobile bar */
(function () {
  function init(root) {
    if (!root || root.dataset.kpReady) return;
    root.dataset.kpReady = '1';

    var dataEl = root.querySelector('[data-kp-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-kp-form]');
    var idInput = root.querySelector('[data-kp-variant-id]');
    var addBtn = root.querySelector('[data-kp-add]');
    var addLabel = root.querySelector('[data-kp-add-label]');
    var errorEl = root.querySelector('[data-kp-error]');
    var sticky = root.querySelector('[data-kp-sticky]');
    var stickyBtn = root.querySelector('[data-kp-sticky-add]');
    var track = root.querySelector('[data-kp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kp-thumb]'));
    var counter = root.querySelector('[data-kp-current]');
    var currentIndex = 0;

    /* ---------- Gallery ---------- */
    function goTo(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      currentIndex = i;
      if (counter) counter.textContent = i + 1;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    if (track && slides.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.kpThumb); }); });
      var prev = root.querySelector('[data-kp-prev]'), next = root.querySelector('[data-kp-next]');
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); }
      });
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      slides.forEach(function (s, i) { if (+s.dataset.mediaId === mediaId) goTo(i); });
    }

    /* ---------- Variants ---------- */
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-kp-option]'));
    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (inp) { if (inp.checked) opts[+inp.dataset.kpOption] = inp.value; });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function currentVariant() {
      var id = +idInput.value;
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return null;
    }
    function setText(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }

    function render(v) {
      var t = data.text;
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = t.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = t.unavailable; }
        return;
      }
      idInput.value = v.id;
      setText('[data-kp-price-now]', v.price);
      setText('[data-kp-sticky-price]', v.price);
      setText('[data-kp-sticky-variant]', v.title);
      setText('[data-kp-sku]', v.sku || '—');
      var was = root.querySelector('[data-kp-price-was]');
      if (was) { if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.hidden = true; } }
      v.options.forEach(function (val, i) { setText('[data-kp-option-value="' + i + '"]', val); });

      var stock = root.querySelector('[data-kp-stock]');
      if (stock) {
        var cls = !v.available ? 'kp-dot kp-dot--off' : (v.mto ? 'kp-dot kp-dot--wait' : 'kp-dot');
        var msg = !v.available ? t.soldOut : (v.mto ? t.mto : t.inStock);
        stock.innerHTML = '<span class="' + cls + '" aria-hidden="true"></span>';
        stock.appendChild(document.createTextNode(msg));
      }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? t.add : t.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? t.add : t.soldOut; }
      showMedia(v.media);

      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } }));
    }
    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', function () { render(findVariant(selectedOptions())); });
    });

    /* ---------- Quantity ---------- */
    var qty = root.querySelector('input[name="quantity"]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-kp-qty]'), function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.kpQty, 10));
      });
    });

    /* ---------- Add to cart (AJAX, falls back to normal form post) ---------- */
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        errorEl.hidden = true;
        addBtn.disabled = true; addLabel.textContent = data.text.adding;
        var body = new FormData(form);
        var root_url = (window.routes && window.routes.cartAddUrl) || '/cart/add';
        fetch(root_url + '.js', { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
            addLabel.textContent = data.text.added;
            var q = parseInt(body.get('quantity'), 10) || 1;
            // Warehouse listens for this to refresh and open the mini cart
            document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: res.j, quantity: q } }));
            setTimeout(function () { addBtn.disabled = false; addLabel.textContent = data.text.add; }, 1800);
          })
          .catch(function (err) {
            errorEl.textContent = err.message; errorEl.hidden = false;
            addBtn.disabled = false; addLabel.textContent = data.text.add;
          });
      });
    }

    /* ---------- Sticky mobile bar ---------- */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var buyVisible = true;
      var update = function () {
        var show = mq.matches && !buyVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        // Hide the bar while the main button is on screen or the page is scrolled above it
        var e = entries[0];
        buyVisible = e.isIntersecting || e.boundingClientRect.top > 0;
        update();
      }).observe(addBtn);
      if (mq.addEventListener) mq.addEventListener('change', update);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.kp'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
